document.addEventListener('alpine:init', () => {

  Alpine.store('stepperIndex', {
    index: 0,
    get getIndex() { return this.index },
    set setIndex(i) { this.index = parseInt(i, 10)}
  });

  Alpine.data('formStepper', (input) => ({
    setIndex(newIndex) {
      this.$store.stepperIndex.index = newIndex
    },
    next() {
      this.setIndex(Math.min(this.activeIndex + 1, input.steps.length - 1));
    },
    prev() {
      this.setIndex(Math.max(this.activeIndex - 1, 0));
    },
    emitEvent(i) {
      this.setIndex(i);
      this.$el.dispatchEvent(
        new Event('stepper-click', {
          bubbles: true,
        }),
      );
    },
    ...input,
  })
  );
});

